module.exports = __webpack_public_path__ + "static/media/EarlyWorkLogo.97e2bde2.svg";